module.exports = __webpack_public_path__ + "img/register-login.febf2999.png";